<template>
    <div>
        <!-- <topSearch></topSearch> -->
        <!-- <breadcrumb></breadcrumb> -->

        <div class="top-title-content">
            <span class="title">수업 및 정산</span>
            <span class="txt">예약되어있던 수업에 대한 출결승인, 정산승인이 가능합니다.</span>
        </div>

        <div class="com-search-content">
            <div class="line">
                <div class="com-calendar-wrap">
                    <single-calendar :start-date="startDate" @update="startDateUpdate"></single-calendar>
                    <div class="com-dash"><span class="dash">~</span></div>
                    <single-calendar :end-date="endDate" @update="endDateUpdate"></single-calendar>
                </div>
                <select-form
                    :select-data="['선택', ...periodTypeList]"
                    :select-value="['', ...periodTypeValueList]"
                    :selected-value="searchPeriod"
                    @update:set="(val) => (searchPeriod = val)"
                ></select-form>
                <div class="com-search-input">
                    <input v-model="searchStr" placeholder="회원명 입력" type="text" v-on:keyup.enter="onEventSearch" />
                    <button class="search-btn" @click="onEventSearch">검색</button>
                </div>
            </div>
            <div class="line">
                <select-form :select-data="['센터명']"></select-form>
                <select-form
                    :select-data="['이용권 구분', '개인', 'OT', '듀엣', '그룹', '쿠폰', '회원권', '운동복']"
                    :select-value="['', 'P', 'O', 'D', 'G', 'C', 'T', 'S']"
                    :selected-value="ticketType"
                    @update:set="(val) => (ticketType = val)"
                ></select-form>
                <select-form
                    :select-data="['이용권명', ...prodList]"
                    :select-value="['', ...prodValList]"
                    :selected-value="prod"
                    class="w240"
                    @update:set="(val) => (prod = val)"
                ></select-form>
                <select-form
                    :select-data="['카테고리명', ...categoryList]"
                    :select-value="['', ...categoryValList]"
                    :selected-value="category"
                    @update:set="(val) => (category = val)"
                ></select-form>
                <select-form
                    :select-data="['출결현황', '전체', '미승인', '결석', '출석']"
                    :select-value="['', '', '-', 'X', 'O']"
                    :selected-value="attendanceCode"
                    @update:set="(val) => (attendanceCode = val)"
                ></select-form>
                <select-form
                    :select-data="['정산현황', '미정산', '정산승인', '정산취소']"
                    :select-value="['', '-', 'O', 'X']"
                    @update:set="(val) => (calculate = val)"
                ></select-form>
                <select-form
                    :disabled="isDisableSelectStaffs"
                    :select-data="['강사명', ...teacherList]"
                    :select-value="['', ...teacherValueList]"
                    :selected-value="teacherStaff"
                    @update:set="(val) => (teacherStaff = val)"
                ></select-form>
                <button class="com-search-reset" @click="resetSearchContent"></button>
            </div>
        </div>

        <div class="com-table-content">
            <div class="com-btn-area">
                <div class="left-box">
                    <button class="com-btn excel" @click="excelDownload">엑셀 다운로드</button>
                </div>
                <div class="right-box">
                    <span class="txt">
                        총
                        <span class="blue">{{ this.pagingInfo.totalItems }}</span>
                        건
                    </span>
                </div>
            </div>
            <table class="com-table">
                <colgroup>
                    <col style="width: 35px" />
                    <col style="width: 90px" />
                    <col style="width: 170px" />
                    <col style="width: 285px" />
                    <col style="width: 130px" />
                    <col style="width: 130px" />
                    <col style="width: 140px" />
                    <col style="width: 100px" />
                    <col style="width: 130px" />
                    <col style="width: 70px" />
                    <col style="width: 140px" />
                </colgroup>
                <thead>
                    <tr>
                        <th>
                            <div class="com-check">
                                <input
                                    id="check-all"
                                    v-model="selectedAll"
                                    name="check-all"
                                    type="checkbox"
                                    @click="checkedAll"
                                />
                                <label for="check-all"></label>
                            </div>
                        </th>
                        <th>회원명</th>
                        <th>
                            <button>수업일자</button>
                        </th>
                        <th>이용권명</th>
                        <th>
                            <button>강사명</button>
                        </th>
                        <th>출결현황</th>
                        <th>결석사유</th>
                        <th>승인자</th>
                        <th>정산현황</th>
                        <th>정산자</th>
                        <th>센터명</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(a, index) in accountList" :key="index">
                        <td>
                            <div class="com-check">
                                <input
                                    :id="index"
                                    v-model="selected"
                                    :value="index"
                                    name="check-user"
                                    type="checkbox"
                                />
                                <label :for="index"></label>
                            </div>
                        </td>
                        <td>{{ a.cls_customer_nm }}</td>
                        <td>{{ a.cls_less_dt | formatDate("YYYY-MM-DD (ddd)") }} {{ a.cls_less_start_tm | formatHourMinutes }}</td>
                        <td class="left">
                            <span v-if="a.cp_ticket_type_cd === 'P'" class="ico type-1">[개인]</span>
                            <span v-if="a.cp_ticket_type_cd === 'G'" class="ico type-2">[그룹]</span>
                            <span v-if="a.cp_ticket_type_cd === 'C'" class="ico type-3">[쿠폰]</span>
                            <span v-if="a.cp_ticket_type_cd === 'T'" class="ico type-4">[회원권]</span>
                            <span v-if="a.cp_ticket_type_cd === 'D'" class="ico type-5">[듀엣]</span>
                            <span v-if="a.cp_ticket_type_cd === 'O'" class="ico type-6">[OT]</span>
                            <span v-if="a.cp_ticket_type_cd === 'S'" class="ico type-8">[운동복]</span>
                            {{ a.cp_namee }}
                        </td>
                        <td>{{ a.cls_less_staff_nm }}</td>
                        <td>
                            <span class="info-line">
                                <!-- <span>{{convertAtnd(a.clsc_atnd_status_cd)}}</span> -->
                                <span v-if="a.clsc_atnd_status_cd == '-'"><span class="blue">미승인</span></span>
                                <span v-if="a.clsc_atnd_status_cd == '-'" class="center">
                                    <button
                                        class="com-btn-small deep-black"
                                        @click="
                                            checkAllowedClickAttendAction(a, () => {
                                                checkAttend(
                                                    a.clsc_join_seq,
                                                    a.cls_center_less_schd_id,
                                                    a.clsc_center_cust_id,
                                                    a.clsc_center_cust_nm,
                                                    a
                                                );
                                            })
                                        "
                                    >
                                        출결승인
                                    </button>
                                </span>
                                <span
                                    v-if="a.clsc_atnd_status_cd == 'O' || a.clsc_atnd_status_cd == 'X'"
                                    class="center"
                                >
                                    <span v-if="a.clsc_atnd_status_cd == 'O'">
                                        <span>출석</span>
                                        ({{ a.clsc_atnd_exec_tm | formatConvertUTC }})
                                    </span>
                                    <span v-if="a.clsc_atnd_status_cd == 'X'">
                                        <span class="red">결석</span>
                                        ({{ a.clsc_atnd_exec_tm | formatConvertUTC }})
                                    </span>
                                    <button
                                        class="com-btn-small gray"
                                        @keydown.enter.prevent
                                        @click="
                                            checkAllowedClickAttendAction(a, () => {
                                                attendCancel(
                                                    a.clsc_join_seq,
                                                    a.cls_center_less_schd_id,
                                                    a.clsc_center_cust_id,
                                                    a
                                                );
                                            })
                                        "
                                    >
                                        출결취소
                                    </button>
                                </span>

                                <!-- <span><span class="red">결석</span> (08.20 11:51)</span>
                            <span class="center">
                                <a href="#" class="com-btn-small deep-black">출결승인</a>
                            </span> -->
                            </span>
                        </td>
                        <td>{{ a.clsc_schd_cancel_rsn }}{{ a.clsc_less_cust_off_rsn }}</td>
                        <!-- 결석사유 -->
                        <td>{{ getApprover(a) }}</td>
                        <!-- <td>{{getApprover(a.cls_atnd_staff_nm)}}</td> -->
                        <td>
                            <span class="info-line">
                                <!-- <span>완료 (08.20 11:58)</span> -->
                                <span v-if="a.clsc_atnd_status_cd == '-'" class="center">
                                    <span>미승인</span>
                                </span>
                                <span v-if="a.clsc_bill_status_cd == 'O'" class="center">
                                    <span>완료{{ a.clsc_bill_exec_tm | formatConvertUTC }}</span>
                                    <button
                                        class="com-btn-small gray"
                                        @keydown.enter.prevent
                                        @click="payCancel(a.cls_center_less_schd_id, a.clsc_center_cust_id)"
                                    >
                                        정산취소
                                    </button>
                                </span>
                                <span
                                    v-if="
                                        (a.clsc_bill_status_cd == 'X' || a.clsc_bill_status_cd == '-') &&
                                        (a.clsc_atnd_status_cd == 'O' || a.clsc_atnd_status_cd == 'X')
                                    "
                                    class="center"
                                >
                                    <span>미정산</span>
                                    <button
                                        class="com-btn-small deep-black"
                                        @keydown.enter.prevent
                                        @click="
                                            payApproval(
                                                a.cls_center_less_schd_id,
                                                a.clsc_center_cust_id,
                                                a.cls_less_staff_id,
                                                a.clsc_center_contract_id 
                                            )
                                        "
                                    >
                                        정산승인
                                    </button>
                                </span>
                            </span>
                        </td>
                        <td>{{ a.cls_bill_staff_nm }}</td>
                        <td>{{ a.cls_center_nm }}</td>
                    </tr>
                    <tr v-if="accountList == 0">
                        <td colspan="100">등록된 내용이 없습니다.</td>
                    </tr>
                </tbody>
            </table>
            <div class="sort-bottom-area">
                <button class="com-btn deep-blue" @click="attendanceAll()" @keydown.enter.prevent>일괄 출석</button>
                <button class="com-btn red" @click="absentAll()" @keydown.enter.prevent>일괄 결석</button>

                <button class="com-btn green" @click="calculateAll()" @keydown.enter.prevent>일괄 정산</button>

                <select-form
                    :select-data="[...sortTypeList]"
                    :select-value="[...sortTypeValueList]"
                    class="float-right"
                    @update:set="changeLimit"
                ></select-form>
            </div>
            <b-pagination
                v-model="pagingInfo.page"
                :per-page="pagingInfo.limit"
                :total-rows="pagingInfo.totalItems"
                align="center"
                aria-controls="my-table"
                first-class="first"
                last-class="last"
                next-class="next"
                prev-class="prev"
                @change="handlerPagenation($event)"
            ></b-pagination>
        </div>
        <!-- 출결승인 팝업 -->
        <div v-show="attendPop" class="layer-pop square-type">
            <div class="view-content w650">
                <button class="close" @click="attendPop = false"><span class="blind">팝업 닫기</span></button>
                <div class="scroll-area com-scroll-y">
                    <span class="sub-title">출결승인</span>
                    <div class="attend-info-area">
                        <span class="top-user">
                            <strong>{{ custName }}</strong>
                            회원님
                            <span v-if="popupInfo.cp_ticket_type_cd === 'P'" class="ico type-1">[개인]</span>
                            <span v-if="popupInfo.cp_ticket_type_cd === 'G'" class="ico type-2">[그룹]</span>
                            <span v-if="popupInfo.cp_ticket_type_cd === 'C'" class="ico type-3">[쿠폰]</span>
                            <span v-if="popupInfo.cp_ticket_type_cd === 'T'" class="ico type-4">[회원권]</span>
                            <span v-if="popupInfo.cp_ticket_type_cd === 'D'" class="ico type-5">[듀엣]</span>
                            <span v-if="popupInfo.cp_ticket_type_cd === 'O'" class="ico type-6">[OT]</span>
                            <span v-if="popupInfo.cp_ticket_type_cd === 'S'" class="ico type-8">[운동복]</span>

                            {{ popupInfo.cp_namee }} : {{ popupInfo.ccp_less_join_cnt }}/{{ popupInfo.ccp_less_cnt }}회
                        </span>
                        <div class="info-box">
                            <span class="time">
                                {{ popupInfo.cls_less_dt | timestampFilter3 }} ({{ popupInfo.cls_less_staff_nm }} 강사)
                            </span>
                            <div class="input-line">
                                <input
                                    v-model="absentReason"
                                    class="w100p"
                                    placeholder="결석일 경우, 사유를 입력해주세요."
                                    type="text"
                                />
                            </div>
                        </div>
                    </div>
                    <div class="bottom-btn">
                        <button class="com-btn blue" @click="attendanceStatus('O')" @keydown.enter.prevent>
                            출석처리
                        </button>
                        <button class="com-btn red" @click="attendanceStatus('X')" @keydown.enter.prevent>
                            결석처리
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import api from '@/assets/js/api';
import moment from 'moment';
import EventBus from '../../../assets/js/eventBus';
import { MixinAllowedMenu } from '@/assets/js/mixinAllowedMenu';
import XLSX from 'xlsx';
import { Utils } from '@/assets/js/utils';
import { pagingInfo } from '@/assets/js/common';

export default {
    name: 'CourseAccount',
    mixins: [MixinAllowedMenu],
    props: {},
    computed: {
        cId() {
            const { getters } = this.$store;
            return getters['auth/cId'];
        },
        isDisableSelectStaffs() {
            return !this.isAllowed('SC', 4);
        },
        uId() {
            const { getters } = this.$store;
            return getters['auth/staffId'];
        },
    },
    watch: {
        searchPeriod(newValue) {
            // 검색 기간 설정 변수
            this.searchPeriod = newValue;

            if (newValue === 'today') {
                // 오늘
                this.startDate = moment().format('YYYY-MM-DD');
                this.endDate = moment().format('YYYY-MM-DD');
            } else if (newValue === 'yesterday') {
                // 어제
                this.startDate = moment().subtract(1, 'days').format('YYYY-MM-DD');
                this.endDate = moment().subtract(1, 'days').format('YYYY-MM-DD');
            } else if (newValue === 'thisMonth') {
                // 이번 달
                this.startDate = moment().startOf('month').format('YYYY-MM-DD');
                this.endDate = moment().endOf('month').format('YYYY-MM-DD');
            } else if (newValue === 'prevMonth') {
                // 지난 달
                this.startDate = moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD');
                this.endDate = moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD');
            } else if (newValue === '3M') {
                // 3개월
                this.startDate = moment().subtract(3, 'months').format('YYYY-MM-DD');
                this.endDate = moment().format('YYYY-MM-DD');
            } else if (newValue === '6M') {
                // 6개월
                this.startDate = moment().subtract(6, 'months').format('YYYY-MM-DD');
                this.endDate = moment().format('YYYY-MM-DD');
            } else if (newValue === '12M') {
                // 12개월
                this.startDate = moment().subtract(12, 'months').format('YYYY-MM-DD');
                this.endDate = moment().format('YYYY-MM-DD');
            } else if (newValue === '') {
                this.initStartDate();
                this.initEndDate();
            }

            // 설정 바꾸면 첫 페이지로 세팅
            this.pagingInfo.page = 1;
            this.onSearchList();
        },
        startDate(newValue) {
            // 검색 시작일
            this.startDate = newValue;

            // 설정 바꾸면 첫 페이지로 세팅
            this.pagingInfo.page = 1;
            this.onSearchList();
        },
        endDate(newValue) {
            // 검색 종료일
            this.endDate = newValue;

            // 설정 바꾸면 첫 페이지로 세팅
            this.pagingInfo.page = 1;
            this.onSearchList();
        },
        ticketType(newValue) {
            this.ticketType = newValue;

            // 설정 바꾸면 첫 페이지로 세팅
            this.pagingInfo.page = 1;
            this.onSearchList();
        },
        category(newValue) {
            this.category = newValue;

            // 설정 바꾸면 첫 페이지로 세팅
            this.pagingInfo.page = 1;
            this.onSearchList();
        },
        teacherStaff(newValue) {
            this.teacherStaff = newValue;

            // 설정 바꾸면 첫 페이지로 세팅
            this.pagingInfo.page = 1;
            this.onSearchList();
        },
        prod(newValue) {
            this.prod = newValue;

            // 설정 바꾸면 첫 페이지로 세팅
            this.pagingInfo.page = 1;
            this.onSearchList();
        },
        calculate(newValue) {
            this.calculate = newValue;

            // 설정 바꾸면 첫 페이지로 세팅
            this.pagingInfo.page = 1;
            this.onSearchList();
        },
        attendanceCode(newValue) {
            this.attendanceCode = newValue;

            // 설정 바꾸면 첫 페이지로 세팅
            this.pagingInfo.page = 1;
            this.onSearchList();
        },
    },
    data() {
        return {
            attendPop: false,
            absentReason: '',
            centerId: '',
            centerLessonScheduleId: '',
            centerCustomerId: '',
            accountList: [],
            itemCount: '',
            startDate: '', // moment().startOf("month").format("YYYY-MM-DD"),
            endDate: '', // moment().endOf("month").format('YYYY-MM-DD'),
            sortTypeList: [...this.$sortType],
            sortTypeValueList: [...this.$sortTypeValue],
            pagingInfo: { ...pagingInfo },
            searchStr: '',
            searchPeriod: 'thisMonth',
            periodTypeList: [...this.$periodTypeList],
            periodTypeValueList: [...this.$periodTypeValueList],
            ticketType: '',
            selectedAll: false,
            selected: [],
            listSortColumn: 'lessonDate',
            listSortType: 'DESC',
            category: '',
            categoryList: [],
            categoryValList: [],
            joinSeq: '',
            teacherList: [], // 강사 직원
            teacherValueList: [],
            teacherStaff: '',
            custName: '',
            popupInfo: {},
            chainCenterId: '', // 체인 센터 아이디

            prodList: [],
            prodValList: [],
            prod: '',
            calculate: '',
            attendanceCode: '-',
        };
    },
    mounted() {
        this.centerId = this.cId; // 센터 Id
        this.pagingInfo.page = 1;
        this.teacherStaff = parseInt(this.uId);
        this.init();
    },
    methods: {
        // 초기화
        async init() {
            this.staffId = parseInt(this.$store.getters['auth/staffId']);
            this.pagingInfo.limit = 10;
            this.initStartDate();
            this.initEndDate();
            await this.onCategoryList(); // 카테고리 리스트
            await this.onFetchTeachers(); // 강사명 조회 값 넣기.
            await this.onProductList(); // 이용권리스트
            await this.onSearchList();
        },
        async onSearchList() {
            try {
                this.isLoading = true;
                const { data } = await this.getSearchList();
                this.setPageParams(data);
                this.accountList = data.items;
                this.itemCount = data.meta.itemCount;
                this.selected = [];
            } catch (error) {
                console.log(error);
                console.log('에러입니다.');
            }
        },
        // 수업 및 정산 리스트 가져오기
        getSearchList() {
            const params = {
                startDate: moment(this.startDate).format('YYYYMMDD'),
                endDate: moment(this.endDate).format('YYYYMMDD'),
                searchStr: this.searchStr,
                ticketType: this.ticketType,
                centerProductCategoryTemplateId: this.category,
                centerProductId: this.prod,
                centerId: this.chainCenterId,
                lessStaffId: this.teacherStaff,
                billStatus: this.calculate, // 정산상태코드
                attendanceStatus: this.attendanceCode, // 출결상태코드
                sortType: this.listSortType,
                sortColumn: this.listSortColumn,
                ...this.pagingInfo,
            };

            if (this.isAllowed('SC', 3) && !this.isAllowed('SC', 4)) {
                // 권한이 본인만인 경우,
                this.teacherStaff = this.staffId;
                params.lessStaffId = this.staffId;
            }

            // 스웨거 검색: 수업및정산 페이징 목록 조회
            return api.get(`/admin/api/center/${this.centerId}/lesson/calculate/search`, { params });
        },
        // 페이징 Param 설정
        setPageParams(data) {
            this.pagingInfo.totalPages = data.meta.totalPages;
            this.pagingInfo.page = data.meta.currentPage;
            this.pagingInfo.totalItems = data.meta.totalItems;
            this.pagingInfo.itemCount = data.meta.itemCount;
        },
        // 검색 시작일 초기화
        initStartDate() {
            const startDate = moment().startOf('month').format('YYYY-MM-DD');
            this.startDate = startDate;
        },

        // 검색 종료일 초기화
        initEndDate() {
            const endDate = moment().endOf('month').format('YYYY-MM-DD');
            this.endDate = endDate;
        },

        // 검색 시작일 변경 event
        startDateUpdate(val) {
            this.startDate = val;
        },

        // 검색 종료일 변경 event
        endDateUpdate(val) {
            this.endDate = val;
        },
        // 한 페이지에 표시되는 줄 수 변경
        changeLimit(val) {
            this.pagingInfo.limit = val;
            this.onSearchList();
        },
        // 회원 목록 키워드 검색 이벤트
        onEventSearch(e) {
            if (this.searchStr.length > 0 && this.searchStr.length < 2) {
                return;
            }

            // 설정 바꾸면 첫 페이지로 세팅
            this.pagingInfo.page = 1;
            this.onSearchList();
        },
        convertAtnd(type) {
            if (type == '-') {
                return '미승인';
            } else if (type == 'O') {
                return '승인';
            } else if (type == 'I') {
                return '입장';
            } else if (type == 'X') {
                return '결석';
            } else if (type == 'W') {
                return '대기';
            }
        },
        // 일괄출석
        async attendanceAll() {
            let mine = true;
            for (const idx of this.selected) {
                if (this.accountList[idx].cls_less_staff_id !== this.staffId) mine = false;
            }

            if (mine && !(this.checkAllowed('SC', 3) || this.checkAllowed('SC', 4))) {
                alert('사용권한이 없습니다. 대표관리자에게 권한을 요청하세요. (본인 권한)');
                return;
            }

            if (!mine && !this.checkAllowed('SC', 4)) {
                alert('사용권한이 없습니다. 대표관리자에게 권한을 요청하세요. (전체 권한)');
                return;
            }

            if (!confirm('일괄 출석처리 하시겠습니까?')) {
                return false;
            }

            try {
                const params = {
                    infos: [],
                };

                this.selected.forEach((idx) => {
                    if (this.accountList[idx].clsc_atnd_status_cd != 'O') {
                        params.infos.push({
                            centerLessonScheduleId: this.accountList[idx].cls_center_less_schd_id,
                            centerCustomerId: this.accountList[idx].clsc_center_cust_id,
                        });
                    }
                });

                await this.getAttendanceAll(params);

                // 설정 바꾸면 첫 페이지로 세팅
                this.pagingInfo.page = 1;
                await this.onSearchList();

                this.selected = [];
            } catch (error) {
                console.log(error);
            }
        },
        // 일괄출석 API
        getAttendanceAll(params) {
            return api.put(`/admin/api/center/${this.centerId}/lesson/calculate/attendance`, params);
        },
        // 일괄결석
        async absentAll() {
            let mine = true;
            for (const idx of this.selected) {
                if (this.accountList[idx].cls_less_staff_id !== this.staffId) mine = false;
            }

            if (mine && !(this.checkAllowed('SC', 3) || this.checkAllowed('SC', 4))) {
                alert('사용권한이 없습니다. 대표관리자에게 권한을 요청하세요. (본인 권한)');
                return;
            }

            if (!mine && !this.checkAllowed('SC', 4)) {
                alert('사용권한이 없습니다. 대표관리자에게 권한을 요청하세요. (전체 권한)');
                return;
            }

            if (!confirm('일괄 결석처리 하시겠습니까?')) {
                return false;
            }

            try {
                const params = {
                    infos: [],
                };

                this.selected.forEach((g) => {
                    if (this.accountList[g].clsc_atnd_status_cd != '0') {
                        params.infos.push({
                            centerLessonScheduleId: this.accountList[g].cls_center_less_schd_id,
                            centerCustomerId: this.accountList[g].clsc_center_cust_id,
                        });
                    }
                });

                await this.getAbsentAll(params);

                // 설정 바꾸면 첫 페이지로 세팅
                this.pagingInfo.page = 1;
                await this.onSearchList();

                this.selected = [];
            } catch (error) {
                console.log(error);
            }
        },
        // 일괄결석 API
        getAbsentAll(params) {
            return api.put(`/admin/api/center/${this.centerId}/lesson/calculate/absent`, params);
        },
        // 일괄정산
        async calculateAll() {
            if (!confirm('일괄정산 하시겠습니까?')) {
                return false;
            }

            try {
                const params = {
                    infos: [],
                };
                let errMsg = '';

                this.selected.forEach((g) => {
                    if (this.accountList[g].clsc_atnd_status_cd == '-') {
                        errMsg = '출결승인되지 않은 데이터가 있습니다.';
                        return false;
                    }

                    if (!this.isAllowed('LE', 7)) {
                        if (this.accountList[g].cls_less_staff_id !== this.staffId) {
                            errMsg = '사용권한이 없습니다. 관리자에게 문의하세요.';
                            return false;
                        }
                    }

                    if (this.accountList[g].clsc_bill_status_cd !== 'O') {
                        params.infos.push({
                            centerLessonScheduleId: this.accountList[g].cls_center_less_schd_id,
                            centerCustomerId: this.accountList[g].clsc_center_cust_id,
                            centerContractId: this.accountList[g].clsc_center_contract_id,
                        });
                    }
                });

                if (errMsg !== '') {
                    alert(errMsg);
                    return false;
                }

                await this.getCalculateAll(params);

                // 설정 바꾸면 첫 페이지로 세팅
                this.pagingInfo.page = 1;
                await this.onSearchList();
            } catch (error) {
                console.log(error);
                console.log('일괄정산 에러입니다');
            }
        },
        // 일괄정산 API
        getCalculateAll(params) {
            return api.put(`/admin/api/center/${this.centerId}/lesson/calculate/calculate`, params);
        },
        checkedAll() {
            // 전체 선택 기능
            this.selected = [];
            if (!this.selectedAll) {
                for (const index in this.accountList) {
                    this.selected.push(index);
                }
            }
        },
        // 각 item별 출결승인 / 취소
        async attendanceStatus(status, joinSeq, lessonId, customerId) {
            console.log('this.absentReason', this.absentReason);
            try {
                const msgTitle = status === 'O' ? '출석' : '결석';
                if (status === 'X' && Utils.isEmpty(this.absentReason.trim())) {
                    alert('결석인 경우 사유를 입력해주세요.');
                    return false;
                }

                if (!confirm(`${msgTitle} 처리 하시겠습니까?`)) {
                    return false;
                }

                if (this.popupInfo.cp_ticket_type_cd === 'G' || this.popupInfo.cp_ticket_type_cd === 'C') {
                    const centerLessonScheduleId = this.popupInfo.cls_center_less_schd_id;
                    const centerCustomerIds = [this.centerCustomerId];
                    if (status === 'O') {
                        await this.putGroupLessonAttendCustomers(centerLessonScheduleId, centerCustomerIds);
                    } else {
                        const lessonCustomerOffReason = this.absentReason;

                        await this.putGroupLessonAbsentCustomers(
                            centerLessonScheduleId,
                            centerCustomerIds,
                            lessonCustomerOffReason
                        );
                    }
                } else {
                    await this.getAttendStatus(status);
                }

                // alert(`${msgTitle}처리 되었습니다.`);

                this.onSearchList();
                this.initAttendanceData();
                this.attendPop = false;
            } catch (error) {
                Utils.alertResponseErrorMessge(error);
            }
        },
        initAttendanceData() {
            this.joinSeq = '';
            this.centerLessonScheduleId = '';
            this.centerCustomerId = '';
            this.custName = '';
            this.popupInfo = {};
            this.absentReason = '';
        },
        // 출결승인 API
        getAttendStatus(status) {
            return api.put(
                `/admin/api/center/${this.centerId}/lesson/schedule/${this.centerLessonScheduleId}/customer/${this.centerCustomerId}/attendance-status`,
                {
                    joinSeq: this.joinSeq,
                    attendanceStatus: status,
                    attendanceDevice: 'AW',
                    scheduleCancelReason: this.absentReason,
                }
            );
        },
        // 정산취소
        async payCancel(lessId, custId) {
            if (!confirm('정산취소하시겠습니까?')) {
                return false;
            }

            try {
                await this.getPayCancel(lessId, custId);
                // alert('정산취소 되었습니다.');

                await this.onSearchList();
            } catch (error) {
                console.log(error);
            }
        },

        // 정산취소API
        getPayCancel(lessId, custId) {
            return api.put(`/admin/api/center/${this.centerId}/lesson/calculate/${lessId}/customer/${custId}/cancel`);
        },

        // 카테고리명 조회
        async onCategoryList() {
            try {
                const { data } = await this.getCategoryList();
                data.forEach((g) => {
                    this.categoryList.push(g.name);
                    this.categoryValList.push(g.centerProductCategoryTemplateId);
                });
            } catch (error) {
                console.log(error);
                console.log('카테고리 값을 가져오는데 실패했습니다.');
            }
        },
        getCategoryList() {
            return api.get(`/admin/api/center/${this.centerId}/product/category/template`);
        },
        // 페이징 이벤트
        handlerPagenation(event) {
            this.pagingInfo.page = event;
            this.onSearchList();
        },
        // 검색 조건 초기화
        resetSearchContent() {
            this.searchType = '';

            // 설정 바꾸면 첫 페이지로 세팅
            this.pagingInfo.page = 1;
            this.onSearchList();
            EventBus.$emit('event:initList', 'init');
        },
        putGroupLessonAttendCustomers(centerLessonScheduleId, centerCustomerIds) {
            // 스웨거: 그룹레슨 출석처리
            const attendanceDevice = 'AW';
            const params = {
                centerId: this.centerId,
                centerLessonScheduleId,
                attendanceDevice,
                centerCustomerIds,
            };

            return api.put(`/admin/api/center/${this.centerId}/lesson/schedule/groupLessonAttend/customers`, {
                ...params,
            });
        },
        putGroupLessonAbsentCustomers(centerLessonScheduleId, centerCustomerIds, lessonCustomerOffReason) {
            // 스웨거: 그룹레슨 결석처리
            const attendanceDevice = 'AW';
            const params = {
                centerId: this.centerId,
                centerLessonScheduleId,
                attendanceDevice,
                centerCustomerIds,
                lessonCustomerOffReason,
            };
            console.log('putGroupLessonAbsentCustomers', params);
            return api.put(`/admin/api/center/${this.centerId}/lesson/schedule/groupLessonAbsent/customers`, {
                ...params,
            });
        },
        // 출결승인처리
        checkAttend(joinSeq, lessonId, customerId, name, a) {
            try {
                this.joinSeq = joinSeq;
                this.centerLessonScheduleId = lessonId;
                this.centerCustomerId = customerId;
                this.custName = name;
                this.popupInfo = a;
                this.attendPop = true;
            } catch (error) {
                console.log(error);
                console.log('출결처리 되지않았습니다.');
            }
        },
        // 출결 취소
        async attendCancel(joinSeq, lessonId, customerId, a) {
            try {
                if (a.clsc_bill_status_cd == 'O') {
                    alert('정산취소를 먼저 해주세요.');
                    return false;
                }

                if (!confirm('출결 취소 하시겠습니까?')) {
                    return false;
                }

                this.joinSeq = joinSeq;
                this.centerLessonScheduleId = lessonId;
                this.centerCustomerId = customerId;
                await this.getAttendStatus('-');
                await this.onSearchList();

                this.initAttendanceData();
            } catch (error) {
                console.log(error);
                console.log('error');
            }
        },
        convertAttend(time) {
            if (time === null || time === '' || time === undefined) {
                return time;
            }
            const result = moment(time).format('MM.DD HH:MM');
            return `(${result})`;
        },
        // 강사 리스트 조회
        async onFetchTeachers() {
            try {
                const { data } = await this.getFetchTeachers();
                data.sort(
                    (
                        a,
                        b // order by 정렬
                    ) => (a.name < b.name ? -1 : a.name > b.name ? 1 : 0)
                );
                console.log('강사 리스트', data);
                data.forEach((g) => {
                    this.teacherList.push(g.name);
                    this.teacherValueList.push(g.centerStaffId);
                });
            } catch (error) {
                console.log(error);
                console.log('에러입니다.');
            }
        },
        // 강사 리스트 조회 api
        getFetchTeachers() {
            return api.get(`/admin/api/center/${this.centerId}/staff/teachers/list`);
        },
        // 정산승인
        async payApproval(lessId, custId, less_staff_id,contractId) {
            if (!this.isAllowed('LE', 7)) {
                if (less_staff_id !== this.staffId) {
                    alert('사용권한이 없습니다. 관리자에게 문의하세요.');
                    return false;
                }
            }

            if (!confirm('승인하시겠습니까?')) {
                return false;
            }

            try {
                await this.getPayApproval(lessId, custId,contractId);
                // alert('정산처리 되었습니다.');
                await this.onSearchList();
            } catch (error) {
                console.log(error);
                console.log('error');
            }
        },
        getPayApproval(lessId, custId,contractId) {
            return api.put(`/admin/api/center/${this.centerId}/lesson/calculate/calculate`, {
                'infos': [
                    {
                        'centerLessonScheduleId': lessId,
                        'centerCustomerId': custId,
                        'centerContractId': contractId,
                    },
                ],
            });
        },
        // 이용권명 조회
        async onProductList() {
            try {
                const { data } = await this.getProductList();
                console.log('이용권명', data);
                data.items.forEach((g) => {
                    this.prodList.push(
                        `[${
                            {
                                P: '개인',
                                G: '그룹',
                                C: '쿠폰',
                                T: '회원권',
                                D: '듀엣',
                                O: 'OT',
                            }[g.cp_ticket_type_cd]
                        }] ${g.cp_namee}`
                    );
                    this.prodValList.push(g.cp_center_prod_id);
                });
            } catch (error) {
                console.log(error);
                console.log('error');
            }
        },
        getProductList() {
            return api.get(`/admin/api/center/${this.centerId}/product/ticket`, {
                params: {
                    ...this.pagingInfo,
                },
            });
        },
        checkAllowedClickAttendAction(sch, successCallback) {
            // 출결 승인 관리 권한
            if (this.isAllowed('SC', 4) || (this.isAllowed('SC', 3) && sch.cls_less_staff_id === this.staffId)) {
                // 전체 권한이 있거나, 본인만 권한이 있는 경우
                successCallback();
            } else {
                alert('사용권한이 없습니다. 대표관리자에게 권한을 요청하세요.');
                return false;
            }
        },
        // 엑셀 다운로드 기능
        async excelDownload() {
            const { data } = await this.getCourseAccountExcel(); // 엑셀용 요청값

            const excelDownloadArray = [];
            data.items.forEach((a) => {
                const temp = {};
                temp['회원명'] = a.clsc_center_cust_nm;
                temp['수업일자'] = `${moment(a.cls_less_dt).format('YYYY-MM-DD')} ${a.cls_less_start_tm
                    .toString()
                    .slice(0, 8)}`;
                temp['이용권명'] = `[${Utils.getTicketTypeName(a.cp_ticket_type_cd)}] ${a.cp_namee}`;
                temp['강사명'] = a.cls_less_staff_nm;
                temp['출결현황'] = Utils.getAttendanceStatusName(a.clsc_atnd_status_cd);
                temp['결석사유'] = a.clsc_schd_cancel_rsn;
                temp['승인자'] =
                    a.clsc_atnd_dev_cd == 'AW' || a.clsc_atnd_dev_cd == 'AA' ? a.cls_less_staff_nm : a.clsc_atnd_dev_cd;
                temp['정산현황'] = Utils.getBillStatusString(a.clsc_atnd_status_cd);
                temp['정산자'] = a.cls_bill_staff_nm;
                temp['센터명'] = a.cls_center_nm;

                excelDownloadArray.push(temp);
            });

            /* [Key:value, ...] */
            const dataWS = XLSX.utils.json_to_sheet(excelDownloadArray);

            // cell width 설정
            const wscols = [
                { wch: 12 },
                { wch: 24 },
                { wch: 50 },
                { wch: 30 },
                { wch: 12 },
                { wch: 35 },
                { wch: 12 },
                { wch: 12 },
                { wch: 12 },
                { wch: 12 },
                { wch: 12 },
            ];
            dataWS['!cols'] = wscols;

            // cell height 설정
            const wsrows = [{ hpx: 30 }];
            dataWS['!rows'] = wsrows;

            const wb = XLSX.utils.book_new();

            XLSX.utils.book_append_sheet(wb, dataWS, '수업 및 정산관리');
            XLSX.writeFile(wb, '수업 및 정산관리.xlsx');
        },
        getCourseAccountExcel() {
            const params = {
                startDate: moment(this.startDate).format('YYYYMMDD'),
                endDate: moment(this.endDate).format('YYYYMMDD'),
                searchStr: this.searchStr,
                ticketType: this.ticketType,
                centerProductCategoryTemplateId: this.category,
                centerProductId: this.prod,
                centerId: this.chainCenterId,
                lessStaffId: this.teacherStaff,
                billStatus: this.calculate, // 정산상태코드
                attendanceStatus: this.attendanceCode, // 출결상태코드
                sortType: this.listSortType,
                sortColumn: this.listSortColumn,
                ...this.pagingInfo,
                limit: 10000,
            };

            if (this.isAllowed('SC', 3) && !this.isAllowed('SC', 4)) {
                // 권한이 본인만인 경우,
                this.teacherStaff = this.staffId;
                params.lessStaffId = this.staffId;
            }

            // 스웨거 검색: 수업및정산 페이징 목록 조회
            return api.get(`/admin/api/center/${this.centerId}/lesson/calculate/search`, { params });
        },
        getApprover(obj) {
            let answer = '';
            if (
                (obj.clsc_atnd_dev_cd === 'AA' || obj.clsc_atnd_dev_cd === 'AW') &&
                (obj.clsc_atnd_status_cd === 'O' || obj.clsc_atnd_status_cd === 'X')
            ) {
                answer = obj.cls_atnd_staff_nm;
            } else if (obj.clsc_atnd_status_cd === '-') {
                answer = '';
            } else {
                answer = '회원';
            }
            return answer;
        },
    },
};
</script>
<style lang="scss"></style>
